import React, { useEffect, useState } from "react";
import {
    Button,
    Card,
    Empty,
    Flex,
    Input,
    Space,
    Tooltip,
    Skeleton,
    message,
    Typography,
    Dropdown,
    Menu,
    Tag,
} from "antd";
import {
    SearchOutlined,
    PlusOutlined,
    ReloadOutlined,
    WarningOutlined,
    EditOutlined,
    CheckCircleOutlined,
    DeleteOutlined,
    DownOutlined,
    LeftOutlined,
    CloseCircleOutlined,
    RightOutlined,
    InboxOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import api from "../../../api";
import RejectionModal from "../Approval/RejectionModal";


const { Title, Text } = Typography;

const MarketPlace = () => {
    const [productData, setProductData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(false);
    const [conditionFilter, setConditionFilter] = useState("All");
    const [marketData, setMarketData] = useState([]);
    const [openRejectionModal, setOpenRejectionModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [actionType, setActionType] = useState(""); // "approve" | "reject"
    const [messageApi, contextHolder] = message.useMessage();
    const [data, setData] = useState([]);
    const [statusFilter, setStatusFilter] = useState("All");



    const [pageSize, setPageSize] = useState(6);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();


    useEffect(() => {
        fetchMarketPlace();
    }, []);

    const fetchMarketPlace = async () => {
        try {
            setLoading(true);

            const payload = {
                synceddatetime: "2025-05-29 10:08:00",
                FormCode: "201",
                AppVersion: "1.0.0.0",
                ApiKey: "kavin",
                AppTypeNo: "3",
            };

            const res = await api.getMarketplace(payload);

            if (res?.data?.status === "1") {
                const mappedData = (res.data.marketplace_data || [])
                    .sort(
                        (a, b) =>
                            new Date(b.fld_system_inserted_datetime || b.fld_created_date) -
                            new Date(a.fld_system_inserted_datetime || a.fld_created_date)
                    )
                    .map((item) => ({
                        id: item.fld_rf_id,
                        name: item.fld_product_name,
                        description: item.fld_product_description,
                        price: item.fld_product_price,
                        condition: item.fld_product_condation_name,
                        rejectedReason: item.fld_reason_for_rejection || "",
                        isReported: false,
                        location: item.fld_location,
                        image: item.fld_image_path || "https://via.placeholder.com/300x180",
                        isApproved: item.fld_is_approval_rejection,
                        email: item.fld_contact_email,
                        mobile: item.fld_contact_mobile,
                        createdDate: item.fld_created_date,
                    }));

                setProductData(mappedData);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    // 🔍 Filters
    const filteredData = productData.filter((item) => {
        const matchesSearch = item.name
            .toLowerCase()
            .includes(searchTerm.toLowerCase());

        const matchesCondition =
            conditionFilter === "All" || item.condition === conditionFilter;

        const matchesStatus =
            statusFilter === "All" ||
            (statusFilter === "Approved" && item.isApproved === "1") ||
            (statusFilter === "Rejected" && item.isApproved === "2") ||
            (statusFilter === "Pending" &&
                (item.isApproved === "0" || !item.isApproved));

        return matchesSearch && matchesCondition && matchesStatus;
    });

    // 📄 Pagination
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedData = filteredData.slice(
        startIndex,
        startIndex + pageSize
    );
    const totalPages = Math.ceil(filteredData.length / pageSize);

    const pageMenu = (
        <Menu
            items={[6, 10, 20].map((num) => ({
                key: num,
                label: num,
                onClick: () => {
                    setPageSize(num);
                    setCurrentPage(1);
                },
            }))}
        />
    );

    const handleConfirmAction = (reason) => {
        if (!selectedItem || !actionType) return;

        handleApproval(selectedItem, actionType, reason);

        setOpenRejectionModal(false);
        setSelectedItem(null);
        setActionType("");
    };

    const handleApproval = async (item, type, reason) => {
        try {
            setLoading(true);

            const payload = {
                fld_rf_id: item.id,
                //  fld_user_id: "admin",
                fld_is_approval_rejection: type === "approve" ? "1" : "2",
                fld_is_approval_rejection_name: type === "approve" ? "approved" : "rejected",
                fld_reason_for_rejection: reason ? reason : "",

                // synceddatetime: "2025-05-29 10:08:00",
                // formcode: "201",
                // appversion: "1.0.0.0",
                // apikey: "kavin",
                // apptypeno: "3"
            };

            const res = await api.marketplaceApproveReject(payload);

            if (res?.data?.status === "1") {
                // ✅ update UI instantly
                fetchMarketPlace()
                messageApi.success(type === "approve" ? "Approved successfully" : "Rejected Successfully");
                setData((prev) =>
                    prev.map((d) =>
                        d.id === item.id
                            ? { ...d, fld_is_approval_rejection: type === "approve" ? "1" : "2" }
                            : d
                    )
                );
            }
        } catch (err) {
            console.error(err);
            messageApi.success(type === "approve" ? "Approved Failed" : "Rejection Failed");

        } finally {
            setLoading(false);
        }
    };

    return (
        <>

            {contextHolder}

            {openRejectionModal && (
                <RejectionModal
                    title={actionType === "approve" ? "Approve Product" : "Reject Product"}
                    content={
                        actionType === "approve"
                            ? "Are you sure you want to approve this Product?"
                            : "Are you sure you want to reject this Product?"
                    }
                    open={openRejectionModal}
                    buttonName={actionType === "approve" ? "Approve" : "Reject"}
                    onClose={() => setOpenRejectionModal(false)}
                    onSubmit={handleConfirmAction}
                />
            )}
            <div className="review-page">
                {/* Header */}
                <Flex
                    className="review-header"
                    justify="space-between"
                    align="center"
                    style={{ marginBottom: 16 }}
                >
                    <Input
                        className="review-search"
                        prefix={<SearchOutlined />}
                        placeholder="Search product..."
                        style={{ width: 300 }}
                        value={searchTerm}
                        onChange={(e) => {
                            setSearchTerm(e.target.value);
                            setCurrentPage(1);
                        }}
                    />

                    {/* <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        style={{ background: "#0072b1" }}
                    >
                        Create Product
                    </Button> */}
                </Flex>

                {/* Title */}
                <div className="review-container">
                    <div className="review-heading">
                        <Title level={4} style={{ margin: 0 }}>
                            Market Place
                        </Title>
                        <Text type="secondary">
                            Manage and track your products
                        </Text>
                    </div>

                    {/* Filters */}
                    <div className="review-filters">
                        <div className="filter-buttons">
                            <Dropdown
                                overlay={
                                    <Menu
                                        items={[

                                            { key: "All", label: "All", onClick: () => setConditionFilter("All") },
                                            { key: "Used", label: "Used", onClick: () => setConditionFilter("Used") },
                                            { key: "New", label: "New", onClick: () => setConditionFilter("New") },
                                        ]}

                                    />
                                }
                            >
                                <Button>
                                    {conditionFilter} <DownOutlined />
                                </Button>
                            </Dropdown>
                            <Dropdown
                                overlay={
                                    <Menu
                                        items={[
                                            {
                                                key: "All",
                                                label: "All Status",
                                                onClick: () => setStatusFilter("All"),
                                            },
                                            {
                                                key: "Approved",
                                                label: "Approved",
                                                onClick: () => setStatusFilter("Approved"),
                                            },
                                            {
                                                key: "Rejected",
                                                label: "Rejected",
                                                onClick: () => setStatusFilter("Rejected"),
                                            },
                                            {
                                                key: "Pending",
                                                label: "Pending",
                                                onClick: () => setStatusFilter("Pending"),
                                            },
                                        ]}
                                    />
                                }
                            >
                                <Button>
                                    Status: {statusFilter} <DownOutlined />
                                </Button>
                            </Dropdown>

                            <Button
                                icon={<ReloadOutlined />}
                                onClick={() => {
                                    setConditionFilter("All");
                                    setStatusFilter("All");
                                    setSearchTerm("");
                                    setCurrentPage(1);
                                }}
                            >
                                Reset
                            </Button>
                        </div>
                    </div>

                    {/* Cards */}
                    {/* Cards - GRID VIEW */}
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
                            gap: 20,
                            marginTop: 16,
                        }}
                    >
                        {loading ? (
                            Array.from({ length: 6 }).map((_, index) => (
                                <Card
                                    key={index}
                                    style={{
                                        borderRadius: 12,
                                        overflow: "hidden",
                                    }}
                                    bodyStyle={{
                                        padding: 12,
                                    }}
                                >
                                    {/* Image */}
                                    <div
                                        style={{
                                            width: "100%",
                                            height: 260, // match your real image area
                                            marginBottom: 12,
                                        }}
                                    >
                                        <Skeleton.Image
                                            active
                                            style={{
                                                width: "100%",
                                                height: "100%",
                                            }}
                                        />
                                    </div>
                                    {/* Status */}
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginBottom: 10,
                                        }}
                                    >
                                        <Skeleton.Button active size="small" style={{ width: 80 }} />
                                    </div>

                                    {/* Title */}
                                    <Skeleton.Input
                                        active
                                        size="small"
                                        style={{
                                            width: "70%",
                                            marginBottom: 10,
                                        }}
                                    />

                                    {/* Description */}
                                    <Skeleton
                                        active
                                        title={false}
                                        paragraph={{
                                            rows: 2,
                                            width: ["100%", "80%"],
                                        }}
                                    />

                                    {/* Tags */}
                                    <Flex gap={8} wrap style={{ marginTop: 10 }}>
                                        <Skeleton.Button active size="small" style={{ width: 70 }} />
                                        <Skeleton.Button active size="small" style={{ width: 80 }} />
                                        <Skeleton.Button active size="small" style={{ width: 70 }} />
                                    </Flex>

                                    {/* Action Buttons */}
                                    <Flex gap={8} style={{ marginTop: 16 }}>
                                        <Skeleton.Button
                                            active
                                            block
                                            style={{ height: 28 }}
                                        />
                                        <Skeleton.Button
                                            active
                                            block
                                            style={{ height: 28 }}
                                        />
                                    </Flex>
                                </Card>
                            ))
                        ) : paginatedData.length === 0 ? (
                            <Card>
                                <Empty
                                    description="No product data"
                                    image={<InboxOutlined style={{ fontSize: 40 }} />}
                                />
                            </Card>
                        ) : (
                            paginatedData.map((item) => (

                                <Card
                                    key={item.id}
                                    hoverable
                                    style={{ borderRadius: 12, overflow: "hidden", display: "flex", flexDirection: "column" }}
                                    bodyStyle={{ display: "flex", flexDirection: "column", flex: 1 }}
                                    onClick={() =>
                                        navigate(`marketplace/${item.id}`, {
                                            state: { marketplaceData: item },
                                        })
                                    }
                                    cover={
                                        <div style={{ position: "relative" }}>
                                            <img
                                                src={item.image}
                                                alt="product"
                                                style={{
                                                    height: 180,
                                                    width: "100%",
                                                    objectFit: "cover",
                                                }}
                                            />

                                            {/* 🔴 Reported Badge */}
                                            {item.isReported && (
                                                <div
                                                    style={{
                                                        position: "absolute",
                                                        top: 10,
                                                        right: 10,
                                                        background: "rgba(255, 77, 79, 0.9)",
                                                        color: "#fff",
                                                        padding: "4px 10px",
                                                        borderRadius: 20,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        gap: 6,
                                                        fontSize: 12,
                                                        fontWeight: 500,
                                                    }}
                                                >
                                                    <WarningOutlined />
                                                    Reported
                                                </div>
                                            )}
                                        </div>
                                    }
                                >

                                    {/* Status */}
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            marginTop: 4,
                                            marginBottom: 8,
                                        }}
                                    >
                                        {item.isApproved === "1" && (
                                            <Tag color="green">Approved</Tag>
                                        )}

                                        {item.isApproved === "2" && (
                                            <Tag color="red">Rejected</Tag>
                                        )}

                                        {(item.isApproved === "0" ||
                                            !item.isApproved) && (
                                                <Tag color="orange">Pending</Tag>
                                            )}
                                    </div>


                                    {/* Title */}
                                    <Text strong style={{ fontSize: 15 }}>
                                        {item.name}
                                    </Text>



                                    {/* Description */}
                                    <div style={{ color: "#888", marginTop: 6 }}>
                                        <div
                                            style={{
                                                display: "-webkit-box",
                                                WebkitLineClamp: 2,
                                                WebkitBoxOrient: "vertical",
                                                overflow: "hidden",
                                            }}
                                        >
                                            {item.description}
                                        </div>
                                    </div>

                                    {/* Info */}
                                    <div style={{ marginTop: 10 }}>
                                        <Tag color="blue">{item.location}</Tag>
                                        <Tag color="green">₹ {item.price}</Tag>
                                        <Tag color={item.condition === "New" ? "green" : "orange"}>
                                            {item.condition}
                                        </Tag>
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            gap: 8,
                                            marginTop: "auto",
                                            paddingTop: 12,
                                        }}
                                    >
                                        {/* ✅ Approved */}
                                        {item.isApproved === "1" && (
                                            <>


                                                <Tooltip title="Reject this item">
                                                    <Button
                                                        size="small"
                                                        type="primary"
                                                        icon={<CloseCircleOutlined />}
                                                        style={{
                                                            flex: 1,
                                                            borderRadius: 6,
                                                            fontWeight: 500,
                                                            fontSize: 12,
                                                            height: 28,
                                                            background: "linear-gradient(135deg, #FF7A7A, #FF4D4F)",
                                                            padding: "0 10px",
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setSelectedItem(item);
                                                            setActionType("reject");
                                                            setOpenRejectionModal(true);
                                                        }}
                                                    >
                                                        Reject
                                                    </Button>
                                                </Tooltip>
                                            </>
                                        )}

                                        {/* ❌ Rejected */}
                                        {/* {item.isApproved === "2" && (
                                            <>


                                                <Tooltip title="Approve this item">
                                                    <Button
                                                        size="small"
                                                        type="primary"
                                                        icon={<CheckCircleOutlined />}
                                                        style={{
                                                            flex: 1,
                                                            background: "linear-gradient(135deg, #73E2A7, #52C41A)",
                                                            borderRadius: 6,
                                                            fontWeight: 500,
                                                            fontSize: 12,
                                                            height: 28,
                                                            padding: "0 10px",
                                                        }}
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            setSelectedItem(item);
                                                            setActionType("approve");
                                                            setOpenRejectionModal(true);
                                                        }}
                                                    >
                                                        Approve
                                                    </Button>
                                                </Tooltip>
                                            </>
                                        )} */}

                                        {/* ⏳ Pending */}
                                        {(item.isApproved === "0" ||
                                            !item.isApproved) && (
                                                <>


                                                    <Tooltip title="Approve this item">
                                                        <Button
                                                            size="small"
                                                            type="primary"
                                                            icon={<CheckCircleOutlined />}
                                                            style={{
                                                                flex: 1,
                                                                background: "linear-gradient(135deg, #73E2A7, #52C41A)",
                                                                borderRadius: 6,
                                                                fontWeight: 500,
                                                                fontSize: 12,
                                                                height: 28,
                                                                padding: "0 10px",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setSelectedItem(item);
                                                                setActionType("approve");
                                                                setOpenRejectionModal(true);
                                                            }}
                                                        >
                                                            Approve
                                                        </Button>
                                                    </Tooltip>

                                                    <Tooltip title="Reject this item">
                                                        <Button
                                                            size="small"
                                                            type="primary"
                                                            icon={<CloseCircleOutlined />}
                                                            style={{
                                                                flex: 1,
                                                                borderRadius: 6,
                                                                fontWeight: 500,
                                                                fontSize: 12,
                                                                height: 28,
                                                                background: "linear-gradient(135deg, #FF7A7A, #FF4D4F)",
                                                                padding: "0 10px",
                                                            }}
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                setSelectedItem(item);
                                                                setActionType("reject");
                                                                setOpenRejectionModal(true);
                                                            }}
                                                        >
                                                            Reject
                                                        </Button>
                                                    </Tooltip>
                                                </>
                                            )}
                                    </div>
                                </Card>
                            ))
                        )}
                    </div>

                    {/* Pagination */}
                    <Flex
                        justify="center"
                        align="center"
                        gap={10}
                        style={{ marginTop: 20 }}
                    >
                        <Button
                            icon={<LeftOutlined />}
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage((p) => p - 1)}
                        />

                        <span>
                            Page {currentPage} of {totalPages || 1}
                        </span>

                        <Button
                            icon={<RightOutlined />}
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage((p) => p + 1)}
                        />

                        <Dropdown overlay={pageMenu}>
                            <Button>
                                {pageSize} / page <DownOutlined />
                            </Button>
                        </Dropdown>
                    </Flex>
                </div>
            </div>
        </>
    );
};

export default MarketPlace;
